<template>
    <div class="blogpost markdown-body" id="blogpost" v-html="data">
    </div>
</template>

<script>
    import Viewer from 'viewerjs'
    import 'viewerjs/dist/viewer.css'

    export default {
        name: "Blogpost",
        props: {
            data: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                viewer: null
            }
        },
        watch: {
            data: {
                handler() {
                    this.$nextTick(() => {
                        this.viewer = new Viewer(document.getElementById('blogpost'), {
                            toolbar: false,
                            navbar: false,
                            title: false
                        })
                    })
                },
                immediate: true
            }
        },
        beforeDestroy() {
            this.viewer.destroy()
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/markdown.scss";
</style>